import React from "react";

const CartColumns = () => {
  return (
    <div className="container-fluid text-center d-none d-lg-block">
      <div className="row">
        <div className="col-10 mx-auto col-lg-2">
          <p className="text-uppercase font-weight-bold">Products</p>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <p className="text-uppercase font-weight-bold">Name of product</p>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <p className="text-uppercase font-weight-bold">price</p>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <p className="text-uppercase font-weight-bold">quantity</p>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <p className="text-uppercase font-weight-bold">remove</p>
        </div>
        <div className="col-10 mx-auto col-lg-2">
          <p className="text-uppercase font-weight-bold">Total</p>
        </div>
      </div>
    </div>
  );
};

export default CartColumns;
